<div class="form-horizontal">
  <div class="appartment-content">
    <div class="appartment-scheme">
      <div class="table-body">
        <table>
          <thead>
            <tr>
              <th>Этаж</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th></th>
            </tr>
            <!-- Технический этаж (чердак) -->
            <ng-container *ngFor="let rooms of auxiliaryPremisesTypes">
              <tr *ngIf="rooms.id === 203">
                <th>{{rooms.title}}</th>
              </tr>
            </ng-container>

            <tr *ngIf="spotObjectAddAppartments.hasMansard">
              <th>Мансарда</th>
            </tr>

            <tr *ngFor="let floors of spotObjectAddAppartments.apartmentCount; let i = index">
              <th>{{floors.floorTitle}}</th>
            </tr>

            <ng-container *ngFor="let commercial of commercialPremisesTypes; let i = index;">
              <tr
                *ngIf="commercial.checked && (commercial.id === 10102 || commercial.id === 10302)">
                <th>{{commercial.title}}</th>
              </tr>
            </ng-container>
            <ng-container *ngFor="let commercial of commercialPremisesTypes; let i = index;">
              <tr
                *ngIf="commercial.checked && (commercial.id === 10101 || commercial.id === 10301)">
                <th>{{commercial.title}}</th>
              </tr>
            </ng-container>

            <!-- Встроенная парковка 1-2 этаж -->
            <ng-container *ngFor="let parking of parkingTypes; let i = index;">
              <tr *ngIf="parking.checked &&  parking.id === 30402">
                <th>{{parking.title}}</th>
              </tr>
            </ng-container>

            <ng-container *ngFor="let parking of parkingTypes; let i = index;">
              <tr *ngIf="parking.checked && parking.id === 30401 ">
                <th>{{parking.title}}</th>
              </tr>
            </ng-container>

            <ng-container *ngFor="let commercial of commercialPremisesTypes; let i = index;">
              <tr *ngIf="commercial.checked && !floorsCommercial">
                <th>{{commercial.title}}</th>
              </tr>
            </ng-container>

            <!-- Цокольный этаж -->
            <ng-container *ngFor="let rooms of auxiliaryPremisesTypes">
              <tr *ngIf="rooms.id === 201">
                <th>{{rooms.title}}</th>
              </tr>
            </ng-container>
            <!-- Подвал -->
            <ng-container *ngFor="let rooms of auxiliaryPremisesTypes">
              <tr *ngIf="rooms.id === 202">
                <th>{{rooms.title}}</th>
              </tr>
            </ng-container>

            <!-- Парковка -->
            <ng-container *ngFor="let parking of parkingTypes; let i = index;">
              <tr *ngIf="parking.checked && (parking.id !== 30401 && parking.id !== 30402 && parking.id !== 304)">
                <th>{{parking.title}}</th>
              </tr>
            </ng-container>
          </tbody>
        </table>
        <table>
          <thead>
            <tr>
              <th colspan="6">
                <span>Пятно {{spotObjectAddAppartments.number}} - Д {{spotObjectAddAppartments.apartment_number}}</span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td *ngFor="let floorRooms of spotObjectAddAppartments.countRooms">
                {{floorRooms.roomCountTitle}}
              </td>
            </tr>
            <!-- Технический этаж (чердак) -->
            <ng-container *ngFor="let rooms of auxiliaryPremisesTypes">
              <tr *ngIf="rooms.id === 203">
                <td colspan="3">
                  <input class="form-control" placeholder="Количество мест" type="number" min="0" max="1000"
                    [(ngModel)]="rooms.placeCount" (ngModelChange)="rooms.placeCount" (change)="changedModel()">
                </td>
                <td colspan="3">
                  <input class="form-control" placeholder="Общая площадь" type="number" min="0" max="1000"
                    [(ngModel)]="rooms.area" (ngModelChange)="rooms.area" (change)="changedModel()">
                </td>
              </tr>
            </ng-container>

            <tr *ngIf="spotObjectAddAppartments.hasMansard">
              <td colspan="3">
                <input class="form-control" placeholder="Количество комнат" type="number" min="0" max="1000"
                  [(ngModel)]="mansardRoom.placeCount" (ngModelChange)="mansardRoom.placeCount = $event"
                  (change)="changedModel()">
              </td>
              <td colspan="3">
                <input class="form-control" placeholder="Общая площадь" type="number" min="0" max="1000"
                  [(ngModel)]="mansardRoom.area" (ngModelChange)="mansardRoom.area = $event" (change)="changedModel()">
              </td>
            </tr>

            <tr *ngFor="let floors of countRoomsOfFloor; let i = index;">
              <td *ngFor="let floor of countRoomsOfFloor[i]; let j = index; trackBy: trackByIdx;">
                <input class="form-control" placeholder="-" type="number" min="0" max="1000"
                  [(ngModel)]="countRoomsOfFloor[i][j]" name="{{i+'-'+j}}" (ngModelChange)="changedCountOfFloors(i, j)">
              </td>
            </tr>

            <!-- commercial.title === '2 - Встроенные' || commercial.title === '2 - Встроенно-пристроенные -->
            <ng-container *ngFor="let secCommercial of commercialPremisesTypes; let i = index;">
              <tr
                *ngIf="secCommercial.checked && (secCommercial.id === 10102 || secCommercial.id === 10302)">
                <td colspan="3">
                  <input class="form-control" placeholder="Количество мест" type="number" min="0" max="1000"
                    [(ngModel)]="secCommercial.placeCount" (ngModelChange)="secCommercial.placeCount = $event"
                    (change)="changedModel()">
                </td>
                <td colspan="3">
                  <input class="form-control" placeholder="Общая площадь" type="number" min="0" max="1000"
                    [(ngModel)]="secCommercial.area" (ngModelChange)="secCommercial.area = $event" (change)="changedModel()">
                </td>
              </tr>
            </ng-container>
            <!-- (commercial.title === '1 - Встроенные' || commercial.title === '1 - Встроенно-пристроенные') -->
            <ng-container *ngFor="let firstcommercial of commercialPremisesTypes; let i = index;">
              <tr
                *ngIf="firstcommercial.checked && (firstcommercial.id === 10101 || firstcommercial.id === 10301)">
                <td colspan="3">
                  <input class="form-control" placeholder="Количество мест" type="number" min="0" max="1000"
                    [(ngModel)]="firstcommercial.placeCount" (ngModelChange)="firstcommercial.placeCount = $event"
                    (change)="changedModel()">
                </td>
                <td colspan="3">
                  <input class="form-control" placeholder="Общая площадь" type="number" min="0" max="1000"
                    [(ngModel)]="firstcommercial.area" (ngModelChange)="firstcommercial.area = $event" (change)="changedModel()">
                </td>
              </tr>
            </ng-container>

            <ng-container *ngFor="let secParking of parkingTypes; let i = index;">
              <tr *ngIf="secParking.checked &&  secParking.id === 30402">
                <td colspan="3">
                  <input class="form-control" placeholder="Количество мест" type="number" min="0" max="1000"
                    [(ngModel)]="secParking.placeCount" (ngModelChange)="secParking.placeCount = $event"
                    (change)="changedModel()">
                </td>
                <td colspan="3">
                  <input class="form-control" placeholder="Общая площадь" type="number" min="0" max="1000"
                    [(ngModel)]="secParking.area" (ngModelChange)="secParking.area = $event" (change)="changedModel()">
                </td>
              </tr>
            </ng-container>

            <ng-container *ngFor="let parking of parkingTypes; let i = index;">
                <tr *ngIf="parking.checked && parking.id === 30401">
                  <td colspan="3">
                    <input class="form-control" placeholder="Количество мест" type="number" min="0" max="1000"
                      [(ngModel)]="parking.placeCount" (ngModelChange)="parking.placeCount = $event"
                      (change)="changedModel()">
                  </td>
                  <td colspan="3">
                    <input class="form-control" placeholder="Общая площадь" type="number" min="0" max="1000"
                      [(ngModel)]="parking.area" (ngModelChange)="parking.area = $event" (change)="changedModel()">
                  </td>
                </tr>
              </ng-container>

            <ng-container *ngFor="let commercial of commercialPremisesTypes; let i = index;">
              <tr *ngIf="commercial.checked && !floorsCommercial">
                <td colspan="3">
                  <input class="form-control" placeholder="Количество мест" type="number" min="0" max="1000"
                    [(ngModel)]="commercial.placeCount" (ngModelChange)="commercial.placeCount = $event"
                    (change)="changedModel()">
                </td>
                <td colspan="3">
                  <input class="form-control" placeholder="Общая площадь" type="number" min="0" max="1000"
                    [(ngModel)]="commercial.area" (ngModelChange)="commercial.area = $event" (change)="changedModel()">
                </td>
              </tr>
            </ng-container>


                 <!-- Цокольный этаж -->
            <ng-container *ngFor="let rooms of auxiliaryPremisesTypes">
              <tr *ngIf="rooms.id === 201">
                <td colspan="3">
                  <input class="form-control" placeholder="Количество мест" type="number" min="0" max="1000"
                    [(ngModel)]="rooms.placeCount" (ngModelChange)="rooms.placeCount" (change)="changedModel()">
                </td>
                <td colspan="3">
                  <input class="form-control" placeholder="Общая площадь" type="number" min="0" max="1000"
                    [(ngModel)]="rooms.area" (ngModelChange)="rooms.area" (change)="changedModel()">
                </td>
              </tr>
            </ng-container>
                 <!-- Подвал -->
            <ng-container *ngFor="let rooms of auxiliaryPremisesTypes">
              <tr *ngIf="rooms.id === 202">
                <td colspan="3">
                  <input class="form-control" placeholder="Количество помещений" type="number" min="0" max="1000"
                    [(ngModel)]="rooms.placeCount" (ngModelChange)="rooms.placeCount" (change)="changedModel()">
                </td>
                <td colspan="3">
                  <input class="form-control" placeholder="Общая площадь" type="number" min="0" max="1000"
                    [(ngModel)]="rooms.area" (ngModelChange)="rooms.area" (change)="changedModel()">
                </td>
              </tr>
            </ng-container>

            <ng-container *ngFor="let parking of parkingTypes; let i = index;">
                <tr *ngIf="parking.checked && (parking.id !== 30401 && parking.id !== 30402 && parking.id !== 304)">
                  <td colspan="3">
                    <input class="form-control" placeholder="Количество мест" type="number" min="0" max="1000"
                      [(ngModel)]="parking.placeCount" (ngModelChange)="parking.placeCount = $event"
                      (change)="changedModel()">
                  </td>
                  <td colspan="3">
                    <input class="form-control" placeholder="Общая площадь" type="number" min="0" max="1000"
                      [(ngModel)]="parking.area" (ngModelChange)="parking.area = $event" (change)="changedModel()">
                  </td>
                </tr>
              </ng-container>

          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div class="incount">Введите количество квартир</div>
  <div class="appartment-action">
    <div class="btn" [ngClass]="onchangeModel ? 'btn-apply' : 'btn-cancel'"
      (click)="onchangeModel ? saveState() : null">Подтвердить</div>
    <div class="btn btn-cancel" (click)="closeModalWindow()">Отменить</div>
  </div>
</div>

<app-modal-window [title]="'Завершение финансирования'" [visible]="changes" (close)="changes = $event"
  [width]="550" [height]="380">
  <div class="confirm">
    <div class="body">
      <div class="warning">
        <img src="./assets/svg-icons/warning.svg" alt="">
      </div>
      <div class="text main"> Удаление квартир возможно только путем нажатия знака ✕ на плитке расположения квартир</div>
      <div class="float_img">
        <img src="./assets/images/float_img.png" alt="float_img" width="80px" height="50px">
      </div>

    </div>
    <div class="btns">
      <div class="btn btn-apply" (click)="acceptChanges()">Подтвердить</div>
      <div class="btn btn-cancel" (click)="cancelChanges()">Отменить</div>
    </div>
  </div>
</app-modal-window>
